<template>
  <div class="clearfix">
    <b-dropdown id="dropdown-1" text="Set Bulk Actions" class="float-left" :variant="shouldStayDisabled ? 'default' : 'success'">

                 <b-dropdown-group id="Set Actions1" header="Set statuses">
                    <b-dropdown-item :disabled="shouldStayDisabled" @click="bulkUpdate('printFileSent', 'yes', 'Set - Print File Sent')">Set - Print File Sent</b-dropdown-item>
                    <b-dropdown-item :disabled="shouldStayDisabled" @click="bulkUpdate('printFileChecked', 'yes', 'Set - Print File Checked')">Set - Print File Checked</b-dropdown-item>
                    <b-dropdown-item :disabled="shouldStayDisabled" @click="bulkUpdate('printFilePrinted', 'yes', 'Set - Print File Printed')">Set - Print File Printed</b-dropdown-item>
                 </b-dropdown-group>
                 
                 <b-dropdown-divider></b-dropdown-divider>
                 
                 <b-dropdown-group id="Set Actions2" header="Group action">
                    <b-dropdown-item :disabled="shouldStayDisabled" @click="groupAction('group')">Group together</b-dropdown-item>
                 </b-dropdown-group>
    
              </b-dropdown>


           <b-btn  @click="showExport" variant="danger" class="m-l-20"><i class="fa fa-search" aria-hidden="true"></i> Search / Export with Filters</b-btn>
            
           <b-dropdown id="dropdown-2" text="Unset Bulk Actions" :variant="shouldStayDisabled ? 'default' : 'danger'" class="m-l-10 float-right" split  :split-variant="shouldStayDisabled ? 'default' : 'outline-danger'">
                <b-dropdown-group id="Unset Actions1" header="Unset statuses"> 
                    <b-dropdown-item :disabled="shouldStayDisabled" @click="bulkUpdate('printFileSent', 'no', 'Unset - Print File Sent')">Unset - Print File Sent</b-dropdown-item>
                    <b-dropdown-item :disabled="shouldStayDisabled" @click="bulkUpdate('printFileChecked', 'no', 'Unset - Print File Checked')">Unset - Print File Checked</b-dropdown-item>
                    <b-dropdown-item :disabled="shouldStayDisabled"  @click="bulkUpdate('printFilePrinted', 'no', 'Unset - Print File Printed')">Unset - Print File Printed</b-dropdown-item>
                </b-dropdown-group>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-group id="Unset Actions2" header="Ungroup actions"> 
                    <b-dropdown-item :disabled="shouldStayDisabled" @click="groupAction('ungroup')">Ungroup Items</b-dropdown-item>
                </b-dropdown-group>
    
              </b-dropdown>
            <a href="" v-if="!shouldStayDisabled" class="float-right m-t-5 m-r-20 text-info" @click.prevent="deselectAll">Deselect All</a>
  </div>
</template>

<script>
import ItemListService from '../../services/item-list.service'
import EventBus from '../../EventBus'

  export default {
      props: {
        selectedItems: {
          type: Array,
          default: () => ([])
        }
      },
      methods: {
         async groupAction(actionType){
            try{

               const confirmPlease = await this.$dialog.confirm(`${actionType.toUpperCase()} : Please confirm to continue`);
               
               if(confirmPlease){

               let data = {
                 ids: this.selectedItems,
                 actionType
               }
               const result = await ItemListService.groupUngroupBulkAction(data);

               EventBus.$emit('items-list.bulk-actions-done', { items: result.data.itemsRecords, field: 'groupHash'})

               this.$store.dispatch('itemsList/setUnsetActiveItemGroup', '')

               this.$toasted.show(result.data.message, {
                type: "success",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              });

             }

            }catch(errors){

              this.$toasted.show(errors.response.data.message, {
                type: "error",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              });

            }
         },
         async bulkUpdate(field, value, actionType){
            try{

              const confirmPlease = await this.$dialog.confirm(`${actionType} : Please confirm to continue`);

              if(confirmPlease){

                  let data = {
                    ids: this.selectedItems,
                    field, 
                    value
                  }

                  const result = await ItemListService.bulkUpdateIndividualField(data);

                  this.$toasted.show(result.data.message, {
                    type: "success",
                    action: {
                      text: "Close",
                      class: "toastBtnTxt",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      },
                    },
                    duration: 5000,
                  });

                  EventBus.$emit('items-list.bulk-actions-done', {items: result.data.itemsRecords, field })

              }
            }catch(errors){
              console.log(errors)

              this.$toasted.show(errors.response.data.message, {
                type: "error",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              });
            }
         },
         deselectAll(){
           EventBus.$emit('items-list.deselect-all');
         },
         showExport(){
            this.$store.dispatch('itemsList/updateIsExportActiveAction', true)
         }
      },
      computed : {
        shouldStayDisabled(){
            if(this.selectedItems.length > 0){
              return false;
            }else{
              return true;
            }
        }
     }
  }
</script>

<style lang="scss" scoped>

</style>